import 'bootstrap';
import './utils';
import './ajax-form';
import './email-lowercase';
import './email-no-plus';
import './porto';
import './countdown';
import './theme';
import './theme.init';
import './ad-banners';
import './coming-up-filter';
import './tour-page/all';
import './tour-page/desktop';
import './tour-page/mobile';
import './form-geolocation';
import './form-country-state';
import './form-checkbox-group';
import './form-phone';
import './register-phone';
import './form-invisible-captcha';
import './form-submit-lock';
import './dynamic-banners';


import MoEngageConnector from './moengage';

// Phone number widgets:
//   ./register-phone - the original AU/NZ-only setup, sign-up and my-details
//                      pages (input[data-phone-au-nz]).
//   ./form-phone     - all countries, every other input[type="tel"]
//                      (generic CMS forms).

window.moEngageVar = new MoEngageConnector();

if (window.__MOENGAGE_DATA__?.moengageOn) {
	moEngageVar.init();
}

